import { Injectable, Pipe, PipeTransform, computed, inject, signal } from '@angular/core';

export type AppLanguage = 'en' | 'hi' | 'pa';

type Dictionary = Record<string, string>;

const STORAGE_KEY = 'nzp_language';

const DICTIONARIES: Record<AppLanguage, Dictionary> = {
  en: {
    account: 'Account',
    active: 'Active',
    addNote: 'Add Note',
    assigned: 'assigned',
    assignedJobs: 'Assigned Jobs',
    changePassword: 'Change Password',
    close: 'Close',
    completedWork: 'Completed Work',
    currentShift: 'Current Shift',
    done: 'Done',
    email: 'Email',
    goodMorning: 'Good morning',
    goodAfternoon: 'Good afternoon',
    goodEvening: 'Good evening',
    home: 'Home',
    hours: 'hours',
    jobRecord: 'Job Record',
    jobs: 'Jobs',
    language: 'Language',
    live: 'Live',
    logOut: 'Log Out',
    me: 'Me',
    noRecentWork: 'Nothing completed recently',
    noTodayWork: 'No work scheduled for today',
    noUpcomingWork: 'No upcoming work assigned',
    noUrgentWork: 'No urgent or paused work right now',
    paused: 'Paused',
    profile: 'Profile',
    projects: 'Projects',
    quoteFollowUp: 'Quote Follow-up',
    recentlyCompleted: 'Recently Completed',
    retry: 'Retry',
    role: 'Role',
    schedule: 'Schedule',
    scheduledJobs: 'Scheduled Jobs',
    shift: 'Shift',
    startShift: 'Start Shift',
    stopShift: 'Stop Shift',
    todayWork: "Today's Work",
    upcoming: 'Upcoming',
    unscheduledJobs: 'Unscheduled Jobs',
    upcomingWork: 'Upcoming Work',
    urgentPausedWork: 'Urgent & Paused Work',
    workSummary: 'Work Summary',
    activatingAccount: 'Activating Account',
    addPhoto: 'Add Photo',
    addToJob: 'Add to Job',
    address: 'Address',
    asBuilt: 'As Built',
    back: 'Back',
    backToLogin: 'Back to Login',
    buildQuote: 'Build Quote',
    cancel: 'Cancel',
    capturePhoto: 'Capture Photo',
    change: 'Change',
    completed: 'Completed',
    confirm: 'Confirm',
    createJob: 'Create Job',
    customer: 'Customer',
    description: 'Description',
    delete: 'Delete',
    downloadPdf: 'Download PDF',
    emailAddress: 'Email Address',
    enterCode: 'Enter the 6-digit code sent to your email.',
    fieldAccount: 'Sign in to your field account',
    forgot: 'Forgot?',
    forgotPassword: 'Forgot Password',
    getDirections: 'Get Directions',
    inspection: 'Inspection',
    inventory: 'Inventory',
    jobDetails: 'Job Details',
    jobMaterials: 'Job Materials',
    jobNotes: 'Job Notes',
    jobPhotos: 'Job Photos',
    loading: 'Loading...',
    loadingJob: 'Loading Job',
    locationDetails: 'Location Details',
    materials: 'Materials',
    newEntry: 'New Entry',
    newOtpSent: 'New OTP sent successfully!',
    newPassword: 'New Password',
    noItemsFound: 'No items found',
    noAppointmentsAssigned: 'No appointments are assigned for this day.',
    noJobsScheduled: 'No Jobs Scheduled',
    noMaterialsLogged: 'No materials logged',
    noNotesYet: 'No Notes Yet',
    noPhotosYet: 'No Photos Yet',
    notes: 'Notes',
    password: 'Password',
    phone: 'Phone',
    project: 'Project',
    projectDetails: 'Project Details',
    readyForOffice: 'Ready for Office',
    resend: 'Resend',
    resendCodeIn: 'Resend code in',
    resetPassword: 'Reset Password',
    save: 'Save',
    savePhoto: 'Save Photo',
    search: 'Search',
    sendResetLink: 'Send Reset Link',
    sending: 'Sending...',
    signIn: 'Sign In',
    startJob: 'Start Job',
    startWork: 'Start Work',
    technicianDetails: 'Technicians Details',
    update: 'Update',
    updatePassword: 'Update Password',
    tools: 'Tools',
    viewAll: 'View all',
    verifyContinue: 'Verify & Continue',
    verifyLogin: 'Verify Login',
    welcomeBack: 'Welcome back'
  },
  hi: {
    account: 'खाता',
    active: 'सक्रिय',
    addNote: 'नोट जोड़ें',
    assigned: 'दिए गए',
    assignedJobs: 'दिए गए काम',
    changePassword: 'पासवर्ड बदलें',
    close: 'बंद करें',
    completedWork: 'पूरा काम',
    currentShift: 'मौजूदा शिफ्ट',
    done: 'पूरा',
    email: 'ईमेल',
    goodMorning: 'सुप्रभात',
    goodAfternoon: 'नमस्ते',
    goodEvening: 'शुभ संध्या',
    home: 'होम',
    hours: 'घंटे',
    jobRecord: 'काम का रिकॉर्ड',
    jobs: 'काम',
    language: 'भाषा',
    live: 'चल रहा',
    logOut: 'लॉग आउट',
    me: 'मैं',
    noRecentWork: 'अभी हाल में कोई काम पूरा नहीं हुआ',
    noTodayWork: 'आज कोई काम तय नहीं है',
    noUpcomingWork: 'आने वाला कोई काम नहीं है',
    noUrgentWork: 'अभी कोई जरूरी या रुका हुआ काम नहीं है',
    paused: 'रुका',
    profile: 'प्रोफाइल',
    projects: 'प्रोजेक्ट',
    quoteFollowUp: 'कोट फॉलो-अप',
    recentlyCompleted: 'हाल में पूरा',
    retry: 'फिर कोशिश करें',
    role: 'भूमिका',
    schedule: 'शेड्यूल',
    scheduledJobs: 'आज के तय काम',
    shift: 'शिफ्ट',
    startShift: 'शिफ्ट शुरू करें',
    stopShift: 'शिफ्ट रोकें',
    todayWork: 'आज का काम',
    upcoming: 'आने वाला',
    unscheduledJobs: 'बिना समय वाले काम',
    upcomingWork: 'आने वाला काम',
    urgentPausedWork: 'जरूरी और रुका काम',
    workSummary: 'काम का सार',
    activatingAccount: 'खाता सक्रिय करें',
    addPhoto: 'फोटो जोड़ें',
    addToJob: 'काम में जोड़ें',
    address: 'पता',
    asBuilt: 'ऐज-बिल्ट',
    back: 'वापस',
    backToLogin: 'लॉगिन पर वापस',
    buildQuote: 'कोट बनाएं',
    cancel: 'रद्द करें',
    capturePhoto: 'फोटो लें',
    change: 'बदलें',
    completed: 'पूरा हुआ',
    confirm: 'पुष्टि करें',
    createJob: 'काम बनाएं',
    customer: 'ग्राहक',
    description: 'विवरण',
    delete: 'हटाएं',
    downloadPdf: 'PDF डाउनलोड करें',
    emailAddress: 'ईमेल पता',
    enterCode: 'ईमेल पर भेजा 6 अंकों का कोड डालें।',
    fieldAccount: 'अपने फील्ड खाते में साइन इन करें',
    forgot: 'भूल गए?',
    forgotPassword: 'पासवर्ड भूल गए',
    getDirections: 'रास्ता देखें',
    inspection: 'इंस्पेक्शन',
    inventory: 'इन्वेंटरी',
    jobDetails: 'काम की जानकारी',
    jobMaterials: 'काम का सामान',
    jobNotes: 'काम के नोट',
    jobPhotos: 'काम की फोटो',
    loading: 'लोड हो रहा है...',
    loadingJob: 'काम लोड हो रहा है',
    locationDetails: 'स्थान की जानकारी',
    materials: 'सामान',
    newEntry: 'नई एंट्री',
    newOtpSent: 'नया OTP भेज दिया गया!',
    newPassword: 'नया पासवर्ड',
    noItemsFound: 'कोई आइटम नहीं मिला',
    noAppointmentsAssigned: 'इस दिन के लिए कोई अपॉइंटमेंट नहीं है।',
    noJobsScheduled: 'कोई काम तय नहीं है',
    noMaterialsLogged: 'कोई सामान दर्ज नहीं',
    noNotesYet: 'अभी कोई नोट नहीं',
    noPhotosYet: 'अभी कोई फोटो नहीं',
    notes: 'नोट',
    password: 'पासवर्ड',
    phone: 'फोन',
    project: 'प्रोजेक्ट',
    projectDetails: 'प्रोजेक्ट जानकारी',
    readyForOffice: 'ऑफिस के लिए तैयार',
    resend: 'फिर भेजें',
    resendCodeIn: 'कोड फिर भेजें',
    resetPassword: 'पासवर्ड रीसेट',
    save: 'सेव',
    savePhoto: 'फोटो सेव करें',
    search: 'खोजें',
    sendResetLink: 'रीसेट लिंक भेजें',
    sending: 'भेज रहे हैं...',
    signIn: 'साइन इन',
    startJob: 'काम शुरू करें',
    startWork: 'काम शुरू करें',
    technicianDetails: 'टेक्नीशियन जानकारी',
    update: 'अपडेट',
    updatePassword: 'पासवर्ड अपडेट करें',
    tools: 'टूल्स',
    viewAll: 'सभी देखें',
    verifyContinue: 'सत्यापित करें और आगे बढ़ें',
    verifyLogin: 'लॉगिन सत्यापित करें',
    welcomeBack: 'वापसी पर स्वागत है'
  },
  pa: {
    account: 'ਖਾਤਾ',
    active: 'ਚਾਲੂ',
    addNote: 'ਨੋਟ ਜੋੜੋ',
    assigned: 'ਦਿੱਤੇ ਹੋਏ',
    assignedJobs: 'ਦਿੱਤੇ ਹੋਏ ਕੰਮ',
    changePassword: 'ਪਾਸਵਰਡ ਬਦਲੋ',
    close: 'ਬੰਦ ਕਰੋ',
    completedWork: 'ਮੁਕੰਮਲ ਕੰਮ',
    currentShift: 'ਮੌਜੂਦਾ ਸ਼ਿਫਟ',
    done: 'ਮੁਕੰਮਲ',
    email: 'ਈਮੇਲ',
    goodMorning: 'ਸਤ ਸ੍ਰੀ ਅਕਾਲ',
    goodAfternoon: 'ਸਤ ਸ੍ਰੀ ਅਕਾਲ',
    goodEvening: 'ਸਤ ਸ੍ਰੀ ਅਕਾਲ',
    home: 'ਹੋਮ',
    hours: 'ਘੰਟੇ',
    jobRecord: 'ਕੰਮ ਦਾ ਰਿਕਾਰਡ',
    jobs: 'ਕੰਮ',
    language: 'ਭਾਸ਼ਾ',
    live: 'ਚੱਲ ਰਿਹਾ',
    logOut: 'ਲੌਗ ਆਉਟ',
    me: 'ਮੈਂ',
    noRecentWork: 'ਹਾਲ ਹੀ ਵਿੱਚ ਕੋਈ ਕੰਮ ਮੁਕੰਮਲ ਨਹੀਂ ਹੋਇਆ',
    noTodayWork: 'ਅੱਜ ਲਈ ਕੋਈ ਕੰਮ ਨਹੀਂ',
    noUpcomingWork: 'ਆਉਣ ਵਾਲਾ ਕੋਈ ਕੰਮ ਨਹੀਂ',
    noUrgentWork: 'ਹੁਣ ਕੋਈ ਜ਼ਰੂਰੀ ਜਾਂ ਰੁਕਿਆ ਕੰਮ ਨਹੀਂ',
    paused: 'ਰੁਕਿਆ',
    profile: 'ਪ੍ਰੋਫਾਈਲ',
    projects: 'ਪ੍ਰੋਜੈਕਟ',
    quoteFollowUp: 'ਕੋਟ ਫਾਲੋ-ਅੱਪ',
    recentlyCompleted: 'ਹਾਲ ਹੀ ਵਿੱਚ ਮੁਕੰਮਲ',
    retry: 'ਮੁੜ ਕੋਸ਼ਿਸ਼',
    role: 'ਭੂਮਿਕਾ',
    schedule: 'ਸ਼ਡਿਊਲ',
    scheduledJobs: 'ਤੈਅ ਕੀਤੇ ਕੰਮ',
    shift: 'ਸ਼ਿਫਟ',
    startShift: 'ਸ਼ਿਫਟ ਸ਼ੁਰੂ ਕਰੋ',
    stopShift: 'ਸ਼ਿਫਟ ਰੋਕੋ',
    todayWork: 'ਅੱਜ ਦਾ ਕੰਮ',
    upcoming: 'ਆਉਣ ਵਾਲਾ',
    unscheduledJobs: 'ਬਿਨਾਂ ਸਮੇਂ ਵਾਲੇ ਕੰਮ',
    upcomingWork: 'ਆਉਣ ਵਾਲਾ ਕੰਮ',
    urgentPausedWork: 'ਜ਼ਰੂਰੀ ਤੇ ਰੁਕਿਆ ਕੰਮ',
    workSummary: 'ਕੰਮ ਦਾ ਸਾਰ',
    activatingAccount: 'ਖਾਤਾ ਚਾਲੂ ਕਰੋ',
    addPhoto: 'ਫੋਟੋ ਜੋੜੋ',
    addToJob: 'ਕੰਮ ਵਿੱਚ ਜੋੜੋ',
    address: 'ਪਤਾ',
    asBuilt: 'ਐਜ਼-ਬਿਲਟ',
    back: 'ਵਾਪਸ',
    backToLogin: 'ਲਾਗਇਨ ਤੇ ਵਾਪਸ',
    buildQuote: 'ਕੋਟ ਬਣਾਓ',
    cancel: 'ਰੱਦ ਕਰੋ',
    capturePhoto: 'ਫੋਟੋ ਲਓ',
    change: 'ਬਦਲੋ',
    completed: 'ਮੁਕੰਮਲ',
    confirm: 'ਪੁਸ਼ਟੀ ਕਰੋ',
    createJob: 'ਕੰਮ ਬਣਾਓ',
    customer: 'ਗਾਹਕ',
    description: 'ਵੇਰਵਾ',
    delete: 'ਮਿਟਾਓ',
    downloadPdf: 'PDF ਡਾਊਨਲੋਡ ਕਰੋ',
    emailAddress: 'ਈਮੇਲ ਪਤਾ',
    enterCode: 'ਈਮੇਲ ਤੇ ਭੇਜਿਆ 6 ਅੰਕਾਂ ਦਾ ਕੋਡ ਪਾਓ।',
    fieldAccount: 'ਆਪਣੇ ਫੀਲਡ ਖਾਤੇ ਵਿੱਚ ਸਾਈਨ ਇਨ ਕਰੋ',
    forgot: 'ਭੁੱਲ ਗਏ?',
    forgotPassword: 'ਪਾਸਵਰਡ ਭੁੱਲ ਗਏ',
    getDirections: 'ਰਸਤਾ ਵੇਖੋ',
    inspection: 'ਇੰਸਪੈਕਸ਼ਨ',
    inventory: 'ਇਨਵੈਂਟਰੀ',
    jobDetails: 'ਕੰਮ ਦੀ ਜਾਣਕਾਰੀ',
    jobMaterials: 'ਕੰਮ ਦਾ ਸਮਾਨ',
    jobNotes: 'ਕੰਮ ਦੇ ਨੋਟ',
    jobPhotos: 'ਕੰਮ ਦੀਆਂ ਫੋਟੋਆਂ',
    loading: 'ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...',
    loadingJob: 'ਕੰਮ ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ',
    locationDetails: 'ਸਥਾਨ ਦੀ ਜਾਣਕਾਰੀ',
    materials: 'ਸਮਾਨ',
    newEntry: 'ਨਵੀਂ ਐਂਟਰੀ',
    newOtpSent: 'ਨਵਾਂ OTP ਭੇਜ ਦਿੱਤਾ ਗਿਆ!',
    newPassword: 'ਨਵਾਂ ਪਾਸਵਰਡ',
    noItemsFound: 'ਕੋਈ ਆਈਟਮ ਨਹੀਂ ਮਿਲੀ',
    noAppointmentsAssigned: 'ਇਸ ਦਿਨ ਲਈ ਕੋਈ ਅਪਾਇੰਟਮੈਂਟ ਨਹੀਂ ਹੈ।',
    noJobsScheduled: 'ਕੋਈ ਕੰਮ ਤੈਅ ਨਹੀਂ',
    noMaterialsLogged: 'ਕੋਈ ਸਮਾਨ ਦਰਜ ਨਹੀਂ',
    noNotesYet: 'ਅਜੇ ਕੋਈ ਨੋਟ ਨਹੀਂ',
    noPhotosYet: 'ਅਜੇ ਕੋਈ ਫੋਟੋ ਨਹੀਂ',
    notes: 'ਨੋਟ',
    password: 'ਪਾਸਵਰਡ',
    phone: 'ਫੋਨ',
    project: 'ਪ੍ਰੋਜੈਕਟ',
    projectDetails: 'ਪ੍ਰੋਜੈਕਟ ਜਾਣਕਾਰੀ',
    readyForOffice: 'ਆਫਿਸ ਲਈ ਤਿਆਰ',
    resend: 'ਮੁੜ ਭੇਜੋ',
    resendCodeIn: 'ਕੋਡ ਮੁੜ ਭੇਜੋ',
    resetPassword: 'ਪਾਸਵਰਡ ਰੀਸੈਟ',
    save: 'ਸੇਵ',
    savePhoto: 'ਫੋਟੋ ਸੇਵ ਕਰੋ',
    search: 'ਖੋਜੋ',
    sendResetLink: 'ਰੀਸੈਟ ਲਿੰਕ ਭੇਜੋ',
    sending: 'ਭੇਜ ਰਹੇ ਹਾਂ...',
    signIn: 'ਸਾਈਨ ਇਨ',
    startJob: 'ਕੰਮ ਸ਼ੁਰੂ ਕਰੋ',
    startWork: 'ਕੰਮ ਸ਼ੁਰੂ ਕਰੋ',
    technicianDetails: 'ਟੈਕਨੀਸ਼ਨ ਜਾਣਕਾਰੀ',
    update: 'ਅਪਡੇਟ',
    updatePassword: 'ਪਾਸਵਰਡ ਅਪਡੇਟ ਕਰੋ',
    tools: 'ਟੂਲ',
    viewAll: 'ਸਾਰੇ ਵੇਖੋ',
    verifyContinue: 'ਪੁਸ਼ਟੀ ਕਰੋ ਤੇ ਅੱਗੇ ਜਾਓ',
    verifyLogin: 'ਲਾਗਇਨ ਪੁਸ਼ਟੀ',
    welcomeBack: 'ਵਾਪਸੀ ਤੇ ਸਵਾਗਤ'
  }
};

@Injectable({ providedIn: 'root' })
export class I18nService {
  readonly languages = [
    { code: 'en' as const, label: 'English' },
    { code: 'hi' as const, label: 'हिन्दी' },
    { code: 'pa' as const, label: 'ਪੰਜਾਬੀ' }
  ];

  readonly language = signal<AppLanguage>(this.readLanguage());
  readonly languageLabel = computed(() => this.languages.find(item => item.code === this.language())?.label || 'English');

  setLanguage(language: AppLanguage) {
    this.language.set(language);
    localStorage.setItem(STORAGE_KEY, language);
    document.documentElement.lang = language;
  }

  translate(key: string): string {
    const current = DICTIONARIES[this.language()] || DICTIONARIES.en;
    return current[key] || DICTIONARIES.en[key] || key;
  }

  private readLanguage(): AppLanguage {
    const stored = localStorage.getItem(STORAGE_KEY) as AppLanguage | null;
    if (stored === 'hi' || stored === 'pa' || stored === 'en') {
      document.documentElement.lang = stored;
      return stored;
    }
    document.documentElement.lang = 'en';
    return 'en';
  }
}

@Pipe({
  name: 't',
  standalone: true,
  pure: false
})
export class TranslatePipe implements PipeTransform {
  private i18n = inject(I18nService);

  transform(key: string): string {
    return this.i18n.translate(key);
  }
}
